import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const LinkIcon = ({ color = '#B5BCBD', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.127 7.411a6.183 6.183 0 0 1 4.66 2.008c.498.545.51 1.364.025 1.922l-.018.021a1.547 1.547 0 0 1-2.303.025 3.107 3.107 0 0 0-3.889-.553c-.259.156-.492.35-.691.574l-.028.03-3.792 4.416a2.913 2.913 0 0 0-.69 2.21c.086.797.5 1.526 1.147 2.022 1.333.972 3.216.752 4.274-.5l1.603-1.866a1.56 1.56 0 0 1 2.154-.188 1.46 1.46 0 0 1 .193 2.097l-1.597 1.86a6.325 6.325 0 0 1-4.29 2.155 6.114 6.114 0 0 1-4.451-1.397c-2.506-2.127-2.812-5.81-.691-8.301l3.782-4.404a6.173 6.173 0 0 1 4.602-2.13zm2.787-4.956c2.143-2.474 5.922-2.835 8.519-.815a5.8 5.8 0 0 1 2.204 4.013 6.004 6.004 0 0 1-1.417 4.492l-3.718 4.33a6.08 6.08 0 0 1-2.723 1.815c-.301.1-.61.176-.922.23-2.031.34-4.102-.339-5.508-1.806a1.46 1.46 0 0 1 .08-2.101 1.56 1.56 0 0 1 2.16.072 3.108 3.108 0 0 0 3.835.499c.259-.156.492-.35.691-.574l.035-.037 3.728-4.343a2.973 2.973 0 0 0-.255-4.181 3.104 3.104 0 0 0-2.249-.739 3.08 3.08 0 0 0-2.112 1.053l-1.793 2.089c-.35.408-.898.603-1.437.512a1.52 1.52 0 0 1-1.173-.955 1.457 1.457 0 0 1 .262-1.466z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

LinkIcon.propTypes = propTypes;

export default LinkIcon;
